import * as React from "react";
import { colorSchemes, shape, typography } from "./themePrimitives";
import {
    ThemeOptions,
    ThemeProvider,
    createTheme,
    type CssVarsThemeOptions,
} from "@mui/material/styles";
import { UX_LOADING } from "lib/uxTokens";
interface AppThemeProps {
    children: React.ReactNode;
    disableCustomTheme?: boolean;
    themeComponents?: ThemeOptions["components"];
}

export default function AppTheme(props: AppThemeProps) {
    const { children, disableCustomTheme } = props;
    
    const theme = createTheme({
        colorSchemes,
        typography,
        shape,
        components: {
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundImage: "none",
                    },
                },
            },
            MuiContainer: {
                styleOverrides: {
                    root: ({ theme }) => ({
                        [theme.breakpoints.only("xs")]: {
                            paddingLeft: theme.spacing(1),
                            paddingRight: theme.spacing(1),
                        },
                    }),
                },
            },
            MuiCircularProgress: {
                defaultProps: {
                    size: UX_LOADING.sectionSpinnerSize,
                },
            },
    },
    } satisfies CssVarsThemeOptions);

    if (disableCustomTheme) return <>{children}</>;

    return (
        <ThemeProvider
            theme={theme}
            defaultMode={
                (typeof window !== "undefined" && localStorage.getItem("color-scheme")) === "dark"
                    ? "dark"
                    : "light"
            }
            modeStorageKey="color-scheme"
            disableTransitionOnChange                  
        >
            {children}
        </ThemeProvider>
    );
}
